
import Typography from '@mui/material/Typography';


export const TextDrugAripiprazole = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Aripiprazole is used to treat the symptoms of schizophrenia (a mental illness that causes disturbed or unusual thinking, loss of interest in life, 
and strong or inappropriate emotions) in adults and teenagers 13 years of age and older. It is also used alone or with other medications 
to treat episodes of mania or mixed episodes (symptoms of mania and depression that happen together) in adults, teenagers, 
and children 10 years of age and older with bipolar disorder (manic-depressive disorder; 
a disease that causes episodes of depression, episodes of mania, and other abnormal moods). <br /><br />
Aripiprazole is also used with an antidepressant to treat depression when symptoms cannot be controlled by the antidepressant alone. 
Aripiprazole is also used to treat children 6 to 17 years of age who have autistic disorder 
(a developmental problem that causes difficulty communicating and interacting with others). Aripiprazole may help control irritable behavior such as aggression, 
temper tantrums, and frequent mood changes in these children. Aripiprazole is also used to treat children 6 to 18 years of age who have Tourette's disorder 
(a condition characterized by the need to perform repeated motions or to repeat sounds or words). 
Aripiprazole is in a class of medications called atypical antipsychotics. It works by changing the activity of certain natural substances in the brain.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a603012.html<br />
https://www.pharmgkb.org/labelAnnotation/PA166104899 

</Typography>

</div>

)
}